import { Address } from "@core/models/address.model";

export function createAddress(params: Partial<Address>) {
  return {
    id              : 0,
    addressable_id  : 0,
    addressable_type: 'none',
    country         : {
      id  : 158,
      name: 'Nederland'
    },
    postal_code     : '',
    city            : '',
    address         : '',
  } as Address;
}
